<ng-container *ngIf="appModeService.isApp(); else webCategoriesView">
  <section class="app-categories-view">
    <header class="app-categories-header">
      <h1>{{ 'APP.CATEGORIES_TITLE' | translate }}</h1>
    </header>

    <div class="app-categories-grid">
      <button type="button" class="app-category-card" *ngFor="let category of categories; trackBy: trackByCategory"
        (click)="goToProductsByCategory(category.name)">
        <img [src]="getCategoryImage(category)" [alt]="category.name" loading="lazy" />
        <span>{{ category.name | uppercase }}</span>
      </button>
    </div>
  </section>
</ng-container>

<ng-template #webCategoriesView>
  <div class="container py-5">
    <h1 class="main-title">Our Categories</h1>
    <div class="app-categories-grid web-grid">
      <button type="button" class="app-category-card" *ngFor="let category of categories; trackBy: trackByCategory"
        (click)="goToProductsByCategory(category.name)">
        <img [src]="getCategoryImage(category)" [alt]="category.name" loading="lazy" />
        <span>{{ category.name | uppercase }}</span>
      </button>
    </div>
  </div>
</ng-template>